import React, { Component } from "react";
import "./css/PurchaseMessage.css";

class PurchaseMessage extends Component {
    render() {
        return (
            <>
                <div className="title title-thin title-xl-2">
                    <h1>Follow the Market</h1>
                </div>
                <div className="lead-s2 lead-light">
                    Follow the prices of Charry (CHY) and Tron against different cryptocurrencies.
                </div>
            </>
        );
    }
}

export default PurchaseMessage;